var $5d3a845adaaa328a$exports = {};
$5d3a845adaaa328a$exports = {
    "pending": `gaida`
};


export {$5d3a845adaaa328a$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
